import { SubComponentModel } from '@secca/case/components/case-plans/case-plans/add-service-order/models/interfaces';

export class SubAirwayBill implements SubComponentModel {
  airwayBillNumber: string;
  remarks: string;
  id: number;

  public constructor(init?: Partial<SubAirwayBill>) {
    Object.assign(this, init);
  }

  isValid(): boolean {
    return true;
  }

}
